var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrendingUp = function SvgTrendingUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 4L8.10246 9.32409L5.97115 8.601L2 12.6667M13.3333 4H10M13.3333 4L13.3333 7.33333",
    stroke: "#8F6408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgTrendingUp;